module.exports = "/assets/data/701f6e932e2d5745cee2cf8dcc6d90ec-NE22.data.json";